var ManageUserAccount = React.createClass({
  propTypes: {
    initialUser: React.PropTypes.object.isRequired,
    editBasicEnabled: React.PropTypes.bool,
    changePasswordEnabled: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      editBasicEnabled: false,
      changePasswordEnabled: false
    }
  },
  getInitialState() {
    return {
      user: this.props.initialUser,
      mode: "view",
      showSaveMessage: false
    }
  },
  saveDone(user) {
    this.setState({user: user,
      mode: "view",
      showSaveMessage: true});

    setTimeout(() => {
      this.setState({showSaveMessage: false})
    }, 2000);
  },
  showEditBasic() {
    this.setState({ mode: "editBasic" });
  },
  showChangePassword() {
    this.setState({ mode : "changePassword" });
  },
  showView() {
    this.setState({ mode: "view" });
  },
  renderEditBasic() {
    return (
      <EditBasicUserForm
        user={this.state.user}
        onSaveDone={this.saveDone}
        onCancel={this.showView} />
    )
  },
  renderChangePassword() {
    return (
      <ChangeUserPasswordForm
        user={this.state.user}
        onSaveDone={this.saveDone}
        onCancel={this.showView} />
    )
  },
  renderView() {
    let {
      user,
      showSaveMessage
    } = this.state;

    return (
      <div>
        <h2 className="h2 account__title">{user.firstName} {user.lastName}</h2>
        <div className="account__subtitle">
          {user.username}<span className="dot" role="presentation"></span><a href={`mailto:${user.emailAddress}`}><span className="sr-only">{Labels.getLabel("email to")}</span>{user.emailAddress}</a>
        </div>

        {this.props.editBasicEnabled ?
          <ul className="bullet-list">
            <li>
              <a href="#" role="button" onClick={this.showEditBasic}>{Labels.getLabel("Edit")}</a>
            </li>
          </ul> : null
        }

        <div className={classNames("account__success-wrap", "alert", "alert-success", {"-in": showSaveMessage})}>
          <span className="text-success">{Labels.getLabel("Save successful")}</span>
        </div>

        <div className="clearfix">
          {this.props.changePasswordEnabled ?
            <div className="account__section">
              <h3 className="account__section-title">{Labels.getLabel("Password")}</h3>
              <div className="account__section-text">
               {Labels.getLabel("Last changed")} {user.password.passwordChangeDateDisplay}
              </div>

              <ul className="bullet-list">
                <li><a href="#" role="button" onClick={this.showChangePassword}>{Labels.getLabel("Change Password")}</a></li>
              </ul>
            </div> : null
          }

          <div className="account__section">
            <h3 className="account__section-title">{Labels.getLabel("More Options")}</h3>

            <ul className="bullet-list">
              <li><a href={`${Config.contextPath}/controller/route/mysubscriptions/view`}>{Labels.getLabel("Email Notifications")}</a></li>
              <li><a href={`${Config.contextPath}/controller/route/userprofile/titlepreferences`}>{Labels.getLabel("Title Preferences")}</a></li>
            </ul>
          </div>
        </div>

      </div>
    )
  },
  render() {
    let {user, mode} = this.state;
    let content;

    if (mode == "editBasic") {
      content = this.renderEditBasic();
    } else if (mode == "changePassword") {
      content = this.renderChangePassword();
    } else {
      content = this.renderView();
    }

    return (
      <div>
        <h1 className="page-title">{Labels.getLabel("My Account")}</h1>

        <section className="section account">
          <div className="account__image">
            <ManageProfileImage user={user} />
          </div>

          <div className="account__content">
            {content}
          </div>
        </section>
      </div>
    )
  }
});